import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ecom-network-check',
  templateUrl: './ecom-network-check.component.html',
  styleUrls: ['./ecom-network-check.component.scss']
})
export class EcomNetworkCheckComponent implements OnInit {
  onlineOffline = true;
  interval:any;
  refreshTime = 5;
  constructor(public router: Router) { }

  ngOnInit() {
    this.onlineOffline = navigator.onLine;
    if(navigator.onLine){
      clearInterval(this.interval);
      this.router.navigate(['home']);
    }
    this.interval = setInterval(()=>{
      this.refreshTime = this.refreshTime - 1;
      if(this.refreshTime === 0){
        this.refreshTime = 5;
        this.router.navigate(['home']);
        clearInterval(this.interval);
      }
    },5000);
  }
}
